import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './inline-list.scss';

const InlineList = ({ children, noMargin }) => {
  const classNames = classnames('sm-inline-list', {
    'sm-inline-list__no-margin': noMargin
  });
  return <ul className={classNames}>{children}</ul>;
};

InlineList.propTypes = {
  children: PropTypes.node,
  noMargin: PropTypes.bool
};

InlineList.defaultProps = {
  children: '',
  noMargin: false
};

export default InlineList;
